/** Survives PWA process kill — used to detect return-from-camera/gallery cold starts. */

const STORAGE_KEY = "file-picker-pending:v1";
const MAX_AGE_MS = 15 * 60 * 1000;

export type FilePickerPendingSource = "gallery";

export type FilePickerPending = {
  startedAt: number;
  source: FilePickerPendingSource;
  feature?: string;
  operation?: string;
};

export function markFilePickerPending(
  source: FilePickerPendingSource,
  context?: {feature?: string; operation?: string},
): void {
  if (typeof localStorage === "undefined") {
    return;
  }

  try {
    const record: FilePickerPending = {
      startedAt: Date.now(),
      source,
      feature: context?.feature,
      operation: context?.operation,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    // private browsing / quota
  }
}

export function clearFilePickerPending(): void {
  if (typeof localStorage === "undefined") {
    return;
  }

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Returns pending session if the app cold-started before the picker completed. */
export function consumeFilePickerKillIfAny(): FilePickerPending | null {
  if (typeof localStorage === "undefined") {
    return null;
  }

  let raw: string | null = null;
  try {
    raw = localStorage.getItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    return null;
  }

  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as FilePickerPending;
    if (!parsed?.startedAt || Date.now() - parsed.startedAt > MAX_AGE_MS) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}
